window.CUR_LAN='cn';
window.TARGET_LAN='en';